import { IDataTableColumn } from 'react-data-table-component';

import StatusCell from '../../../sharedModules/layout/StatusCell';

import { BackflowJobGroup } from '../../model';

const parseDate = (dateStr: string | undefined): number => {
  if (!dateStr) return 0;
  const [datePart, timePart] = dateStr.split(' ');
  const [month, day, year] = (datePart || '').split('/');
  if (!month || !day || !year) return 0;
  const [hours, minutes] = (timePart || '00:00').split(':');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes)).getTime();
};

const dateSortFunction = (field: string) => (a: BackflowJobGroup, b: BackflowJobGroup) => {
  return parseDate(a[field]) - parseDate(b[field]);
};

export const backflowJobGroupsColumns = (): IDataTableColumn<BackflowJobGroup>[] => {
  const baseColumns: IDataTableColumn<BackflowJobGroup>[] = [
    {
      name: 'Scheduled',
      selector: 'schedule_dates',
      sortable: true,
      grow: 0.75,
      sortFunction: dateSortFunction('schedule_dates'),
    },
    {
      name: 'Completed',
      selector: 'completed_at',
      sortable: true,
      sortFunction: dateSortFunction('completed_at'),
      grow: 0.75,
    },
    {
      name: 'Created',
      selector: 'created_in_servman',
      sortable: true,
      sortFunction: dateSortFunction('created_in_servman'),
      grow: 0.75,
    },
    {
      name: 'Required',
      selector: 'required_at',
      sortable: true,
      sortFunction: dateSortFunction('required_at'),
      grow: 0.75,
    },
    {
      name: 'Type',
      selector: 'src_type',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Order',
      selector: 'order_no',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Customer',
      selector: 'company_name',
      sortable: true,
    },
    {
      name: 'Address',
      selector: 'address',
      grow: 2,
      sortable: true,
    },
    {
      name: 'Water Authority',
      selector: 'water_authority_name',
      sortable: true,
      cell: (row) =>
        row.water_authority_name === 'Missing' ? (
          <span style={{ color: 'red', fontWeight: 700, textTransform: 'uppercase' }}>MISSING</span>
        ) : (
          <span>{row.water_authority_name}</span>
        ),
    },
    {
      name: 'Authority-Provided Fields',
      selector: 'authority_provided_values_complete',
      sortable: true,
      cell: (row) => <StatusCell status={row.authority_provided_values_complete} />,
    },
    {
      name: 'Assets',
      selector: 'asset_count',
      sortable: true,
      grow: 0.25,
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      cell: (row) => <StatusCell status={row.status} />,
      grow: 0.75,
    },
  ];

  return baseColumns;
};
